module.exports = __webpack_public_path__ + "static/media/tooltips-maya.c5bf77cd.png";